import React from "react";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Breadcrumbs = ({ items = [] }) => (
  <nav data-testid="breadcrumbs" className="flex items-center gap-2 text-sm text-slate-500 mb-6 flex-wrap">
    {items.map((it, i) => (
      <React.Fragment key={i}>
        {i > 0 && <ChevronLeft className="w-4 h-4 text-slate-300 rotate-180" />}
        {it.to ? (
          <Link to={it.to} className="hover:text-brand transition-colors font-medium">{it.label}</Link>
        ) : (
          <span className="text-brand-dark font-semibold">{it.label}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default Breadcrumbs;
